module.exports = __webpack_public_path__ + "img/sentra2.f4df5b55.jpeg";